export default __webpack_public_path__ + "static/media/Visage of Elder Shadows.b9a2b4c2.jpg";